<div class="row">
  <div class="col-12 card card-bar" ng-show="progressPercent > 0"
    style="margin: 0px;padding: 0px 20px 0px 5px;border-radius: 20px;background:unset;">
    <div class="item item-text-wrap" style="background: #d9d8e7;border-radius: 20px;">
      <div class="loader" [ngStyle]="{'width': progressPercent }">
        <p class="percent">{{displayText}}</p>
      </div>
    </div>
  </div>
</div>